import React from 'react';
import './ReturnPolicy.css';

const ReturnPolicy = () => {
  return (
    <div className="return-policy-container">
      <h1>Return Policy</h1>

      <p>
        This Return Policy applies to all purchases made through Ober Artisan Drums.
        By making a purchase on this site, you acknowledge and agree to these terms.
        We may update this policy at any time without prior notice, and the version in effect
        at the time of your payment will apply. For the purposes of this policy, "payment" refers to the date
        on which your first payment (whether partial or full) is processed, not the date of any agreed-upon
        build proposals or quotes. Please read carefully to understand what is eligible for return or refund.
      </p>

      <h2>1. Handcrafted Drums</h2>
      <p>
        Our handcrafted drums are custom-built and one-of-a-kind. As such, they are <strong>non-refundable</strong> except in the following cases:
      </p>
      <p>
        <strong>Damaged or Defective Items:</strong> If your drum arrives damaged or with a defect, contact us within <strong>7 days</strong> of delivery with photos and a description of the issue. We will work with you to resolve it via repair or replacement.
      </p>
      <p>
        <strong>Post-Delivery Repairs:</strong> We offer post-delivery adjustments and repairs for a fee. Please contact us to inquire about services.
      </p>

      <h2>2. Apparel &amp; Merchandise</h2>
      <p>
        We accept returns and exchanges on apparel and eligible merchandise under the following conditions:
      </p>
      <p>
        <strong>Return Window:</strong> Returns must be initiated within <strong>30 days</strong> of the purchase date.
        <br />
        <strong>Item Condition:</strong> Items must be unworn, unwashed, and in original condition with all tags attached. Used or damaged items will not be accepted.
        <br />
        <strong>Exchanges:</strong> Exchanges are permitted within the return window. Customers are responsible for return shipping unless the item was defective or incorrect.
        <br />
        <strong>Refunds:</strong> Upon inspection and approval of the return, refunds will be issued to the original payment method. Please allow up to <strong>7 business days</strong> for processing.
        <br />
        <strong>Non-Returnable:</strong> Items such as stickers, tools, or other small accessories are final sale and may not be returned unless defective.
      </p>

      <h2>3. Services</h2>
      <p>
        All service purchases (e.g., consultations, workshops, drum tuning) are <strong>non-refundable</strong> once booked or rendered.
      </p>
      <p>
        <strong>Dissatisfaction:</strong> If you are unhappy with a completed service, contact us within <strong>7 days</strong> and we will attempt to address your concerns.
        <br />
        <strong>Rescheduling:</strong> Appointments may be rescheduled with <strong>at least 48 hours’ notice</strong>. No-shows or last-minute cancellations are forfeited.
      </p>

      <h2>4. Pre-Orders and Custom Orders</h2>
      <p>
        All custom and pre-order items are <strong>non-refundable</strong> once production has begun. This includes:
      </p>
      <ul>
        <li>Custom drum builds</li>
        <li>Drum kits</li>
        <li>Engraved or limited-edition items</li>
      </ul>
      <p>
        If your custom item is damaged upon arrival, please contact us within <strong>7 days</strong> for a resolution.
      </p>

      <h2>5. Order Cancellations</h2>
      <p>
        <strong>Custom Drums:</strong> May be canceled within <strong>48 hours</strong> of payment initiation if production has not started. After that, cancellations are not permitted.
        <br /><br />
        <strong>All Other Items:</strong> Orders for in-stock merchandise may be canceled any time before shipment. Please email <strong>support@oberartisandrums.com</strong> as soon as possible.
      </p>

      <h2>6. Return Instructions</h2>
      <p>
        To request a return or exchange, follow these steps:
      </p>
      <p>
        <strong>Step 1 – Contact:</strong> Email <strong>support@oberartisandrums.com</strong> with your order number and reason for return. Attach photos if applicable.
        <br />
        <strong>Step 2 – Authorization:</strong> If eligible, we will provide return instructions. Unauthorized returns will not be processed.
        <br />
        <strong>Step 3 – Shipping:</strong> Return shipping is the customer’s responsibility unless the item arrived damaged or incorrect.
        <br />
        <strong>Step 4 – Inspection &amp; Refund:</strong> Once received and approved, we’ll issue a refund or send a replacement. Refunds may take up to <strong>7 business days</strong> to reflect.
      </p>

      <h2>7. Payment Plans, Promotions, and Bundle Discounts</h2>
      <p>
        <strong>Payment Plans:</strong> From time to time, we may offer payment plans as part of special promotions or at our sole discretion.
        These plans are extended as a courtesy and are not guaranteed. All scheduled payments must be made on time. Failure to complete payments as
        agreed may result in production delays, suspension of work, and/or forfeiture of your order without refund of amounts already paid.
        <br /><br />
        <strong>Promotional &amp; Early-Bird Pricing:</strong> Early-bird and promotional offers are time-limited and only valid if the initial payment
        is received by the stated deadline. Once production begins, all payments are <strong>non-refundable</strong>, and promotional pricing cannot be applied retroactively.
        <br /><br />
        <strong>Bundle Discounts:</strong> Bundle-specific discounts (e.g., drum + side snare promotions) only apply if the bundled items are purchased and paid for together.
        If the bundle is broken or altered, the discount is void and standard pricing applies to any remaining items.
      </p>

      {/* NEW: Klarna refunds/cancellations */}
      <h2>9. Klarna Refunds &amp; Cancellations</h2>
      <p>
        If you paid with Klarna, approved refunds are processed back through Klarna. Partial refunds are applied first against any remaining installments;
        Klarna adjusts future payments or returns any difference to your original payment method per Klarna’s rules. Refund timing is controlled by Klarna
        and may take up to 14 days to reflect on your account after we issue the refund.
      </p>
      <p>
        For custom, made-to-order drums that are non-refundable under Sections 1, 4, and 5, Klarna repayments remain your responsibility under your agreement
        with Klarna. We cannot alter your Klarna contract or payment schedule.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        For questions or support with a return, please reach out to us at <strong>support@oberartisandrums.com</strong>. We’re here to help.
      </p>
    </div>
  );
};

export default ReturnPolicy;